import { checkEmailPhoneLastValidatedDate, validatePhoneValue, saveEmailOrPhoneValidatedData, updateEmailOrPhoneValidatedData, validateEmailValue, getLocationMastersByMasterIds, getAllContactsByIds } from '../redux/actions/vendor'
import { toast } from '../components/CommonComponents/ToastComponent/toast'
import { stateCodesList } from '../utils/countryISO/countryISO'
import { getAccessToken } from '../redux/actions/user'
import { CREATE_TWILIO_DEVICE, CREATE_TWILIO_TOKEN } from '../redux/actionTypes/caller'
import { getContactNameForSuccessfulEnablement } from '../redux/actions/caller'

export const formatValue = (value, type, length = 2, currencySign = '$') => {
  const valueFixed = parseFloat(value || 0).toFixed(length)
  switch (type) {
    case 'currency':
      return currencySign + valueFixed.toLocaleString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
    case 'percent':
      return valueFixed.toString() + '%'
    case 'number':
      return valueFixed.toLocaleString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
    default:
      return valueFixed
  }
}

export const formatCurrency = (value, currencySign, currencyRate) => (
  formatValue(value * currencyRate, 'currency', 2, currencySign)
)

export const sumProperty = (obj, prop) => {
  if (Array.isArray(obj) && obj.length > 0) {
    return obj.reduce((total, cur) => {
      if (cur[prop] && typeof cur[prop] === 'string' && (cur[prop].indexOf('$') !== -1 || cur[prop].indexOf(',') !== -1 || cur[prop].indexOf('%') !== -1)) {
        cur[prop] = parseFloat(cur[prop].replace(/[$,%]/g, ''))
      }
      if (!cur[prop]) {
        cur[prop] = 0
      }
      return total + parseFloat(cur[prop])
    }, 0)
  }
  return 0
}

export const parseMoneyAsFloat = (value, currency_sign) => {
  const valueStr = value.toString()
  return parseFloat(valueStr.replace(new RegExp(`[$,%${currency_sign}]`, 'g'), ''))
}

export const checkSpecialCharater = (str) => {
  const regexp = /[`ģń~!@#$%^*()_|=?;:",<>{}[]\\\/]/gi
  return str.match(regexp)
}

export const getSpecialKeywords = (keywords) => {
  let result = []
  keywords.map(keyword => {
    const textFormat = keyword.keywordText.trim()
    if (checkSpecialCharater(textFormat)) {
      result = [...result, keyword]
    }

    if (textFormat.length > 80) {
      result = [...result, keyword]
    }

    const words = textFormat.split(' ')
    if (keyword.matchType === 'negativeExact' && words.length > 10) {
      result = [...result, keyword]
    }

    if (keyword.matchType === 'negativePhrase' && words.length > 4) {
      result = [...result, keyword]
    }

    return ''
  })
  return result
}

export const isDiffTwoObj = (obj1, obj2) => {
  let isDiff = false
  if (!obj1 || !obj2) {
    return false
  }
  Object.keys(obj1).every(field => {
    if (!obj1.hasOwnProperty(field) || !obj2.hasOwnProperty(field) || (!obj1[field] && !obj2[field])) {
      isDiff = false
    } else if (obj1[field] !== obj2[field]) {
      isDiff = true
      return false
    }
    return true
  })
  return isDiff
}

// Function to create Supplier Basic Info Change Log
export const generateSupplierBasicInfoChangeLog = (supplierOldData = '', supplierNewData = '') => {
  var changeLog = '';
  if (('suppliername' in supplierNewData) && (supplierNewData?.suppliername || supplierOldData?.baseInfo?.suppliername) && supplierOldData?.baseInfo?.suppliername !== supplierNewData?.suppliername) {
    changeLog += 'Supplier Name ' + getChangelogString(supplierOldData?.baseInfo?.suppliername, supplierNewData?.suppliername);
  }
  if (('address1' in supplierNewData) && (supplierNewData?.address1 || supplierOldData?.baseInfo?.address1) && supplierOldData?.baseInfo?.address1 !== supplierNewData?.address1) {
    changeLog += ', Supplier Address1 ' + getChangelogString(supplierOldData?.baseInfo?.address1, supplierNewData?.address1);
  }
  if (('address2' in supplierNewData) && (supplierNewData?.address2 || supplierOldData?.baseInfo?.address2) && supplierOldData?.baseInfo?.address2 !== supplierNewData?.address2) {
    changeLog += ', Supplier Address2 ' + getChangelogString(supplierOldData?.baseInfo?.address2, supplierNewData?.address2);
  }
  if (('city' in supplierNewData) && (supplierNewData?.city || supplierOldData?.baseInfo?.city) && supplierOldData?.baseInfo?.city !== supplierNewData?.city) {
    changeLog += ', Supplier City ' + getChangelogString(supplierOldData?.baseInfo?.city, supplierNewData?.city);
  }
  if (('state' in supplierNewData) && (supplierNewData?.state || supplierOldData?.baseInfo?.state) && supplierOldData?.baseInfo?.state !== supplierNewData?.state) {
    changeLog += ', Supplier State ' + getChangelogString(supplierOldData?.baseInfo?.state, supplierNewData?.state);
  }
  if (('country' in supplierNewData) && (supplierNewData?.country || supplierOldData?.baseInfo?.country) && supplierOldData?.baseInfo?.country !== supplierNewData?.country) {
    changeLog += ', Supplier Country ' + getChangelogString(supplierOldData?.baseInfo?.country, supplierNewData?.country);
  }
  if (('phone' in supplierNewData) && (supplierNewData?.phone || supplierOldData?.baseInfo?.phone) && supplierOldData?.baseInfo?.phone !== supplierNewData?.phone) {
    changeLog += ', Supplier Phone ' + getChangelogString(supplierOldData?.baseInfo?.phone, supplierNewData?.phone);
  }
  if (('email' in supplierNewData) && (supplierNewData?.email || supplierOldData?.baseInfo?.email) && supplierOldData?.baseInfo?.email !== supplierNewData?.email) {
    changeLog += ', Supplier Email ' + getChangelogString(supplierOldData?.baseInfo?.email, supplierNewData?.email);
  }
  if (('sic' in supplierNewData) && (supplierNewData?.sic || supplierOldData?.baseInfo?.sic) && supplierOldData?.baseInfo?.sic !== supplierNewData?.sic) {
    changeLog += ', Supplier SIC Code ' + getChangelogString(supplierOldData?.baseInfo?.sic, supplierNewData?.sic);
  }
  if (('naics' in supplierNewData) && (supplierNewData?.naics || supplierOldData?.baseInfo?.naics) && supplierOldData?.baseInfo?.naics !== supplierNewData?.naics) {
    changeLog += ', Supplier NAICS Code ' + getChangelogString(supplierOldData?.baseInfo?.naics, supplierNewData?.naics);
  }
  if (('zip' in supplierNewData) && (supplierNewData?.zip || supplierOldData?.baseInfo?.zip) && supplierOldData?.baseInfo?.zip !== supplierNewData?.zip) {
    changeLog += ', Supplier Zip ' + getChangelogString(supplierOldData?.baseInfo?.zip, supplierNewData?.zip);
  }
  if (('employerIdNumber' in supplierNewData) && (supplierNewData?.employerIdNumber || supplierOldData?.baseInfo?.employerIdNumber) && supplierOldData?.baseInfo?.employerIdNumber !== supplierNewData?.employerIdNumber) {
    changeLog += ', Supplier Employer Id Number ' + getChangelogString(supplierOldData?.baseInfo?.employerIdNumber, supplierNewData?.employerIdNumber);
  }
  if (('url' in supplierNewData) && (supplierNewData?.url || supplierOldData?.baseInfo?.url) && supplierOldData?.baseInfo?.url !== supplierNewData?.url) {
    changeLog += ', Supplier URL ' + getChangelogString(supplierOldData?.baseInfo?.url, supplierNewData?.url);
  }
  if (('parentOrganizationId' in supplierNewData) && (supplierOldData?.baseInfo?.parentOrganizationId || supplierNewData?.parentOrganizationId) && supplierOldData?.baseInfo?.parentOrganizationId !== supplierNewData?.parentOrganizationId) {
    changeLog += ', Supplier Parent Organization ' + getChangelogString(supplierOldData?.baseInfo?.parentOrganization, supplierNewData?.parentOrganization);
  }
  if (('dbaSupplierName' in supplierNewData) && (supplierNewData?.dbaSupplierName || supplierOldData?.baseInfo?.dbaSupplierName) && supplierOldData?.baseInfo?.dbaSupplierName !== supplierNewData?.dbaSupplierName) {
    changeLog += ', DBA Supplie name ' + getChangelogString(supplierOldData?.baseInfo?.dbaSupplierName, supplierNewData?.dbaSupplierName);
  }
  if (('industry' in supplierNewData) && (supplierNewData?.industry || supplierOldData?.baseInfo?.industry) && supplierOldData?.baseInfo?.industry !== supplierNewData?.industry) {
    changeLog += ', Supplier industry ' + getChangelogString(supplierOldData?.baseInfo?.industry, supplierNewData?.industry);
  }
  if (('linkedinUrl' in supplierNewData) && (supplierNewData?.linkedinUrl || supplierOldData?.baseInfo?.linkedinUrl) && supplierOldData?.baseInfo?.linkedinUrl !== supplierNewData?.linkedinUrl) {
    changeLog += ', Supplier Linkedin Url ' + getChangelogString(supplierOldData?.baseInfo?.linkedinUrl, supplierNewData?.linkedinUrl);
  }

  return changeLog.replace(/(^, )|(, $)/g, '')
}

// to get Supplier Card Acceptance Change Log
export const generateCardAcceptanceChangeLog = (supplierOldData, supplierNewData, addEmailValues, removeEmailValues) => {
  let changeLog = '';
  let oldReadableText = ''
  let newReadableText = ''
  if (('isAcceptAmericanExpress' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptAmericanExpress !== supplierNewData?.isAcceptAmericanExpress) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptAmericanExpress)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptAmericanExpress)
    changeLog += 'Accepts AMEX updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptMasterCard' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptMasterCard !== supplierNewData?.isAcceptMasterCard) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptMasterCard)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptMasterCard)
    changeLog += ', Accepts MasterCard updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptVisa' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptVisa !== supplierNewData?.isAcceptVisa) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptVisa)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptVisa)
    changeLog += ', Accepts Visa updated from ' + oldReadableText + ' to ' + newReadableText;
  }

  if (('americanExpressMinPaymnet' in supplierNewData) && (supplierNewData?.americanExpressMinPaymnet || supplierOldData?.cardInfo?.americanExpressMinPaymnet) && supplierOldData?.cardInfo?.americanExpressMinPaymnet !== supplierNewData?.americanExpressMinPaymnet) {
    changeLog += ', AMEX Minimum Payment ' + getChangelogString(supplierOldData?.cardInfo?.americanExpressMinPaymnet, supplierNewData?.americanExpressMinPaymnet);
  }
  if (('americanExpressMaxPayment' in supplierNewData) && (supplierNewData?.americanExpressMaxPayment || supplierOldData?.cardInfo?.americanExpressMaxPayment) && supplierOldData?.cardInfo?.americanExpressMaxPayment !== supplierNewData?.americanExpressMaxPayment) {
    changeLog += ', AMEX Maximum Payment ' + getChangelogString(supplierOldData?.cardInfo?.americanExpressMaxPayment, supplierNewData?.americanExpressMaxPayment);
  }
  if (('americanExpressPercentFee' in supplierNewData) && (supplierNewData?.americanExpressPercentFee || supplierOldData?.cardInfo?.americanExpressPercentFee) && supplierOldData?.cardInfo?.americanExpressPercentFee !== supplierNewData?.americanExpressPercentFee) {
    changeLog += ', AMEX Percent Fee ' + getChangelogString(supplierOldData?.cardInfo?.americanExpressPercentFee, supplierNewData?.americanExpressPercentFee);
  }
  if (('americanExpressDollarFee' in supplierNewData) && (supplierNewData?.americanExpressDollarFee || supplierOldData?.cardInfo?.americanExpressDollarFee) && supplierOldData?.cardInfo?.americanExpressDollarFee !== supplierNewData?.americanExpressDollarFee) {
    changeLog += ', AMEX Dollar Fee ' + getChangelogString(supplierOldData?.cardInfo?.americanExpressDollarFee, supplierNewData?.americanExpressDollarFee);
  }

  if (('amexProcessingFeeType' in supplierNewData) && (supplierNewData?.amexProcessingFeeType || supplierOldData?.cardInfo?.amexProcessingFeeType) && supplierOldData?.cardInfo?.amexProcessingFeeType !== supplierNewData?.amexProcessingFeeType) {
    changeLog += ', AMEX Processing Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.amexProcessingFeeType, supplierNewData?.amexProcessingFeeType);
  }
  if (('amexProcessingFeeValue' in supplierNewData) && (supplierNewData?.amexProcessingFeeValue || supplierOldData?.cardInfo?.amexProcessingFeeValue) && supplierOldData?.cardInfo?.amexProcessingFeeValue !== supplierNewData?.amexProcessingFeeValue) {
    changeLog += ', AMEX Processing Fee ' + getChangelogString(supplierOldData?.cardInfo?.amexProcessingFeeValue, supplierNewData?.amexProcessingFeeValue);
  }
  if (('amexSecondProcessingFeeType' in supplierNewData) && (supplierNewData?.amexSecondProcessingFeeType || supplierOldData?.cardInfo?.amexSecondProcessingFeeType) && supplierOldData?.cardInfo?.amexSecondProcessingFeeType !== supplierNewData?.amexSecondProcessingFeeType) {
    changeLog += ', AMEX Second Processing Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.amexSecondProcessingFeeType, supplierNewData?.amexSecondProcessingFeeType);
  }
  if (('amexSecondProcessingFeeValue' in supplierNewData) && (supplierNewData?.amexSecondProcessingFeeValue || supplierOldData?.cardInfo?.amexSecondProcessingFeeValue) && supplierOldData?.cardInfo?.amexSecondProcessingFeeValue !== supplierNewData?.amexSecondProcessingFeeValue) {
    changeLog += ', AMEX Second Processing Fee ' + getChangelogString(supplierOldData?.cardInfo?.amexSecondProcessingFeeValue, supplierNewData?.amexSecondProcessingFeeValue);
  }
  if (('amexMinPaymentFeeType' in supplierNewData) && (supplierNewData?.amexMinPaymentFeeType || supplierOldData?.cardInfo?.amexMinPaymentFeeType) && supplierOldData?.cardInfo?.amexMinPaymentFeeType !== supplierNewData?.amexMinPaymentFeeType) {
    changeLog += ', AMEX Minimum Payment Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.amexMinPaymentFeeType, supplierNewData?.amexMinPaymentFeeType);
  }
  if (('amexMinPaymentFeeValue' in supplierNewData) && (supplierNewData?.amexMinPaymentFeeValue || supplierOldData?.cardInfo?.amexMinPaymentFeeValue) && supplierOldData?.cardInfo?.amexMinPaymentFeeValue !== supplierNewData?.amexMinPaymentFeeValue) {
    changeLog += ', AMEX Minimum Payment Fee ' + getChangelogString(supplierOldData?.cardInfo?.amexMinPaymentFeeValue, supplierNewData?.amexMinPaymentFeeValue);
  }
  if (('amexMaxPaymentFeeType' in supplierNewData) && (supplierNewData?.amexMaxPaymentFeeType || supplierOldData?.cardInfo?.amexMaxPaymentFeeType) && supplierOldData?.cardInfo?.amexMaxPaymentFeeType !== supplierNewData?.amexMaxPaymentFeeType) {
    changeLog += ', AMEX Maximum Payment Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.amexMaxPaymentFeeType, supplierNewData?.amexMaxPaymentFeeType);
  }
  if (('amexMaxPaymentFeeValue' in supplierNewData) && (supplierNewData?.amexMaxPaymentFeeValue || supplierOldData?.cardInfo?.amexMaxPaymentFeeValue) && supplierOldData?.cardInfo?.amexMaxPaymentFeeValue !== supplierNewData?.amexMaxPaymentFeeValue) {
    changeLog += ', AMEX Maximum Payment Fee ' + getChangelogString(supplierOldData?.cardInfo?.amexMaxPaymentFeeValue, supplierNewData?.amexMaxPaymentFeeValue);
  }
  if (('amexIncrementalFeeType' in supplierNewData) && (supplierNewData?.amexIncrementalFeeType || supplierOldData?.cardInfo?.amexIncrementalFeeType) && supplierOldData?.cardInfo?.amexIncrementalFeeType !== supplierNewData?.amexIncrementalFeeType) {
    changeLog += ', AMEX Incremental Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.amexIncrementalFeeType, supplierNewData?.amexIncrementalFeeType);
  }
  if (('amexIncrementalFeeValue' in supplierNewData) && (supplierNewData?.amexIncrementalFeeValue || supplierOldData?.cardInfo?.amexIncrementalFeeValue) && supplierOldData?.cardInfo?.amexIncrementalFeeValue !== supplierNewData?.amexIncrementalFeeValue) {
    changeLog += ', AMEX Incremental Fee ' + getChangelogString(supplierOldData?.cardInfo?.amexIncrementalFeeValue, supplierNewData?.amexIncrementalFeeValue);
  }
  if (('amexIncrementalPaymentAmount' in supplierNewData) && (supplierNewData?.amexIncrementalPaymentAmount || supplierOldData?.cardInfo?.amexIncrementalPaymentAmount) && supplierOldData?.cardInfo?.amexIncrementalPaymentAmount !== supplierNewData?.amexIncrementalPaymentAmount) {
    changeLog += ', AMEX Incremental Payment Amount ' + getChangelogString(supplierOldData?.cardInfo?.amexIncrementalPaymentAmount, supplierNewData?.amexIncrementalPaymentAmount);
  }

  if (('visaMinPayment' in supplierNewData) && (supplierNewData?.visaMinPayment || supplierOldData?.cardInfo?.visaMinPayment) && supplierOldData?.cardInfo?.visaMinPayment !== supplierNewData?.visaMinPayment) {
    changeLog += ', Visa Minimum Payment ' + getChangelogString(supplierOldData?.cardInfo?.visaMinPayment, supplierNewData?.visaMinPayment);
  }
  if (('visaMaxPayment' in supplierNewData) && (supplierNewData?.visaMaxPayment || supplierOldData?.cardInfo?.visaMaxPayment) && supplierOldData?.cardInfo?.visaMaxPayment !== supplierNewData?.visaMaxPayment) {
    changeLog += ', Visa Maximum Payment ' + getChangelogString(supplierOldData?.cardInfo?.visaMaxPayment, supplierNewData?.visaMaxPayment);
  }
  if (('visaPercentFee' in supplierNewData) && (supplierNewData?.visaPercentFee || supplierOldData?.cardInfo?.visaPercentFee) && supplierOldData?.cardInfo?.visaPercentFee !== supplierNewData?.visaPercentFee) {
    changeLog += ', Visa Percent Fee ' + getChangelogString(supplierOldData?.cardInfo?.visaPercentFee, supplierNewData?.visaPercentFee);
  }
  if (('visaDollarFee' in supplierNewData) && (supplierNewData?.visaDollarFee || supplierOldData?.cardInfo?.visaDollarFee) && supplierOldData?.cardInfo?.visaDollarFee !== supplierNewData?.visaDollarFee) {
    changeLog += ', Visa Dollar Fee ' + getChangelogString(supplierOldData?.cardInfo?.visaDollarFee, supplierNewData?.visaDollarFee);
  }

  if (('visaProcessingFeeType' in supplierNewData) && (supplierNewData?.visaProcessingFeeType || supplierOldData?.cardInfo?.visaProcessingFeeType) && supplierOldData?.cardInfo?.visaProcessingFeeType !== supplierNewData?.visaProcessingFeeType) {
    changeLog += ', Visa Processing Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.visaProcessingFeeType, supplierNewData?.visaProcessingFeeType);
  }
  if (('visaProcessingFeeValue' in supplierNewData) && (supplierNewData?.visaProcessingFeeValue || supplierOldData?.cardInfo?.visaProcessingFeeValue) && supplierOldData?.cardInfo?.visaProcessingFeeValue !== supplierNewData?.visaProcessingFeeValue) {
    changeLog += ', Visa Processing Fee ' + getChangelogString(supplierOldData?.cardInfo?.visaProcessingFeeValue, supplierNewData?.visaProcessingFeeValue);
  }
  if (('visaSecondProcessingFeeType' in supplierNewData) && (supplierNewData?.visaSecondProcessingFeeType || supplierOldData?.cardInfo?.visaSecondProcessingFeeType) && supplierOldData?.cardInfo?.visaSecondProcessingFeeType !== supplierNewData?.visaSecondProcessingFeeType) {
    changeLog += ', Visa Second Processing Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.visaSecondProcessingFeeType, supplierNewData?.visaSecondProcessingFeeType);
  }
  if (('visaSecondProcessingFeeValue' in supplierNewData) && (supplierNewData?.visaSecondProcessingFeeValue || supplierOldData?.cardInfo?.visaSecondProcessingFeeValue) && supplierOldData?.cardInfo?.visaSecondProcessingFeeValue !== supplierNewData?.visaSecondProcessingFeeValue) {
    changeLog += ', Visa Second Processing Fee ' + getChangelogString(supplierOldData?.cardInfo?.visaSecondProcessingFeeValue, supplierNewData?.visaSecondProcessingFeeValue);
  }
  if (('visaMinPaymentFeeType' in supplierNewData) && (supplierNewData?.visaMinPaymentFeeType || supplierOldData?.cardInfo?.visaMinPaymentFeeType) && supplierOldData?.cardInfo?.visaMinPaymentFeeType !== supplierNewData?.visaMinPaymentFeeType) {
    changeLog += ', Visa Minimum Payment Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.visaMinPaymentFeeType, supplierNewData?.visaMinPaymentFeeType);
  }
  if (('visaMinPaymentFeeValue' in supplierNewData) && (supplierNewData?.visaMinPaymentFeeValue || supplierOldData?.cardInfo?.visaMinPaymentFeeValue) && supplierOldData?.cardInfo?.visaMinPaymentFeeValue !== supplierNewData?.visaMinPaymentFeeValue) {
    changeLog += ', Visa Minimum Payment Fee ' + getChangelogString(supplierOldData?.cardInfo?.visaMinPaymentFeeValue, supplierNewData?.visaMinPaymentFeeValue);
  }
  if (('visaMaxPaymentFeeType' in supplierNewData) && (supplierNewData?.visaMaxPaymentFeeType || supplierOldData?.cardInfo?.visaMaxPaymentFeeType) && supplierOldData?.cardInfo?.visaMaxPaymentFeeType !== supplierNewData?.visaMaxPaymentFeeType) {
    changeLog += ', Visa Maximum Payment Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.visaMaxPaymentFeeType, supplierNewData?.visaMaxPaymentFeeType);
  }
  if (('visaMaxPaymentFeeValue' in supplierNewData) && (supplierNewData?.visaMaxPaymentFeeValue || supplierOldData?.cardInfo?.visaMaxPaymentFeeValue) && supplierOldData?.cardInfo?.visaMaxPaymentFeeValue !== supplierNewData?.visaMaxPaymentFeeValue) {
    changeLog += ', Visa Maximum Payment Fee ' + getChangelogString(supplierOldData?.cardInfo?.visaMaxPaymentFeeValue, supplierNewData?.visaMaxPaymentFeeValue);
  }
  if (('visaIncrementalFeeType' in supplierNewData) && (supplierNewData?.visaIncrementalFeeType || supplierOldData?.cardInfo?.visaIncrementalFeeType) && supplierOldData?.cardInfo?.visaIncrementalFeeType !== supplierNewData?.visaIncrementalFeeType) {
    changeLog += ', Visa Incremental Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.visaIncrementalFeeType, supplierNewData?.visaIncrementalFeeType);
  }
  if (('visaIncrementalFeeValue' in supplierNewData) && (supplierNewData?.visaIncrementalFeeValue || supplierOldData?.cardInfo?.visaIncrementalFeeValue) && supplierOldData?.cardInfo?.visaIncrementalFeeValue !== supplierNewData?.visaIncrementalFeeValue) {
    changeLog += ', Visa Incremental Fee ' + getChangelogString(supplierOldData?.cardInfo?.visaIncrementalFeeValue, supplierNewData?.visaIncrementalFeeValue);
  }
  if (('visaIncrementalPaymentAmount' in supplierNewData) && (supplierNewData?.visaIncrementalPaymentAmount || supplierOldData?.cardInfo?.visaIncrementalPaymentAmount) && supplierOldData?.cardInfo?.visaIncrementalPaymentAmount !== supplierNewData?.visaIncrementalPaymentAmount) {
    changeLog += ', Visa Incremental Payment Amount ' + getChangelogString(supplierOldData?.cardInfo?.visaIncrementalPaymentAmount, supplierNewData?.visaIncrementalPaymentAmount);
  }

  if (('mastercardMinPayment' in supplierNewData) && (supplierNewData?.mastercardMinPayment || supplierOldData?.cardInfo?.mastercardMinPayment) && supplierOldData?.cardInfo?.mastercardMinPayment !== supplierNewData?.mastercardMinPayment) {
    changeLog += ', MasterCard Minimum Payment ' + getChangelogString(supplierOldData?.cardInfo?.mastercardMinPayment, supplierNewData?.mastercardMinPayment);
  }
  if (('mastercardMaxPayment' in supplierNewData) && (supplierNewData?.mastercardMaxPayment || supplierOldData?.cardInfo?.mastercardMaxPayment) && supplierOldData?.cardInfo?.mastercardMaxPayment !== supplierNewData?.mastercardMaxPayment) {
    changeLog += ', MasterCard Maximum Payment ' + getChangelogString(supplierOldData?.cardInfo?.mastercardMaxPayment, supplierNewData?.mastercardMaxPayment);
  }
  if (('mastercardPercentFee' in supplierNewData) && (supplierNewData?.mastercardPercentFee || supplierOldData?.cardInfo?.mastercardPercentFee) && supplierOldData?.cardInfo?.mastercardPercentFee !== supplierNewData?.mastercardPercentFee) {
    changeLog += ', MasterCard Percent Fee ' + getChangelogString(supplierOldData?.cardInfo?.mastercardPercentFee, supplierNewData?.mastercardPercentFee);
  }
  if (('mastercardDollarFee' in supplierNewData) && (supplierNewData?.mastercardDollarFee || supplierOldData?.cardInfo?.mastercardDollarFee) && supplierOldData?.cardInfo?.mastercardDollarFee !== supplierNewData?.mastercardDollarFee) {
    changeLog += ', MasterCard Dollar Fee ' + getChangelogString(supplierOldData?.cardInfo?.mastercardDollarFee, supplierNewData?.mastercardDollarFee);
  }

  if (('mastercardProcessingFeeType' in supplierNewData) && (supplierNewData?.mastercardProcessingFeeType || supplierOldData?.cardInfo?.mastercardProcessingFeeType) && supplierOldData?.cardInfo?.mastercardProcessingFeeType !== supplierNewData?.mastercardProcessingFeeType) {
    changeLog += ', MasterCard Processing Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.mastercardProcessingFeeType, supplierNewData?.mastercardProcessingFeeType);
  }
  if (('mastercardProcessingFeeValue' in supplierNewData) && (supplierNewData?.mastercardProcessingFeeValue || supplierOldData?.cardInfo?.mastercardProcessingFeeValue) && supplierOldData?.cardInfo?.mastercardProcessingFeeValue !== supplierNewData?.mastercardProcessingFeeValue) {
    changeLog += ', MasterCard Processing Fee ' + getChangelogString(supplierOldData?.cardInfo?.mastercardProcessingFeeValue, supplierNewData?.mastercardProcessingFeeValue);
  }
  if (('mastercardSecondProcessingFeeType' in supplierNewData) && (supplierNewData?.mastercardSecondProcessingFeeType || supplierOldData?.cardInfo?.mastercardSecondProcessingFeeType) && supplierOldData?.cardInfo?.mastercardSecondProcessingFeeType !== supplierNewData?.mastercardSecondProcessingFeeType) {
    changeLog += ', MasterCard Second Processing Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.mastercardSecondProcessingFeeType, supplierNewData?.mastercardSecondProcessingFeeType);
  }
  if (('mastercardSecondProcessingFeeValue' in supplierNewData) && (supplierNewData?.mastercardSecondProcessingFeeValue || supplierOldData?.cardInfo?.mastercardSecondProcessingFeeValue) && supplierOldData?.cardInfo?.mastercardSecondProcessingFeeValue !== supplierNewData?.mastercardSecondProcessingFeeValue) {
    changeLog += ', MasterCard Second Processing Fee ' + getChangelogString(supplierOldData?.cardInfo?.mastercardSecondProcessingFeeValue, supplierNewData?.mastercardSecondProcessingFeeValue);
  }
  if (('mastercardMinPaymentFeeType' in supplierNewData) && (supplierNewData?.mastercardMinPaymentFeeType || supplierOldData?.cardInfo?.mastercardMinPaymentFeeType) && supplierOldData?.cardInfo?.mastercardMinPaymentFeeType !== supplierNewData?.mastercardMinPaymentFeeType) {
    changeLog += ', MasterCard Minimum Payment Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.mastercardMinPaymentFeeType, supplierNewData?.mastercardMinPaymentFeeType);
  }
  if (('mastercardMinPaymentFeeValue' in supplierNewData) && (supplierNewData?.mastercardMinPaymentFeeValue || supplierOldData?.cardInfo?.mastercardMinPaymentFeeValue) && supplierOldData?.cardInfo?.mastercardMinPaymentFeeValue !== supplierNewData?.mastercardMinPaymentFeeValue) {
    changeLog += ', MasterCard Minimum Payment Fee ' + getChangelogString(supplierOldData?.cardInfo?.mastercardMinPaymentFeeValue, supplierNewData?.mastercardMinPaymentFeeValue);
  }
  if (('mastercardMaxPaymentFeeType' in supplierNewData) && (supplierNewData?.mastercardMaxPaymentFeeType || supplierOldData?.cardInfo?.mastercardMaxPaymentFeeType) && supplierOldData?.cardInfo?.mastercardMaxPaymentFeeType !== supplierNewData?.mastercardMaxPaymentFeeType) {
    changeLog += ', MasterCard Maximum Payment Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.mastercardMaxPaymentFeeType, supplierNewData?.mastercardMaxPaymentFeeType);
  }
  if (('mastercardMaxPaymentFeeValue' in supplierNewData) && (supplierNewData?.mastercardMaxPaymentFeeValue || supplierOldData?.cardInfo?.mastercardMaxPaymentFeeValue) && supplierOldData?.cardInfo?.mastercardMaxPaymentFeeValue !== supplierNewData?.mastercardMaxPaymentFeeValue) {
    changeLog += ', MasterCard Maximum Payment Fee ' + getChangelogString(supplierOldData?.cardInfo?.mastercardMaxPaymentFeeValue, supplierNewData?.mastercardMaxPaymentFeeValue);
  }
  if (('mastercardIncrementalFeeType' in supplierNewData) && (supplierNewData?.mastercardIncrementalFeeType || supplierOldData?.cardInfo?.mastercardIncrementalFeeType) && supplierOldData?.cardInfo?.mastercardIncrementalFeeType !== supplierNewData?.mastercardIncrementalFeeType) {
    changeLog += ', MasterCard Incremental Fee Type ' + getChangelogString(supplierOldData?.cardInfo?.mastercardIncrementalFeeType, supplierNewData?.mastercardIncrementalFeeType);
  }
  if (('mastercardIncrementalFeeValue' in supplierNewData) && (supplierNewData?.mastercardIncrementalFeeValue || supplierOldData?.cardInfo?.mastercardIncrementalFeeValue) && supplierOldData?.cardInfo?.mastercardIncrementalFeeValue !== supplierNewData?.mastercardIncrementalFeeValue) {
    changeLog += ', MasterCard Incremental Fee ' + getChangelogString(supplierOldData?.cardInfo?.mastercardIncrementalFeeValue, supplierNewData?.mastercardIncrementalFeeValue);
  }
  if (('mastercardIncrementalPaymentAmount' in supplierNewData) && (supplierNewData?.mastercardIncrementalPaymentAmount || supplierOldData?.cardInfo?.mastercardIncrementalPaymentAmount) && supplierOldData?.cardInfo?.mastercardIncrementalPaymentAmount !== supplierNewData?.mastercardIncrementalPaymentAmount) {
    changeLog += ', MasterCard Incremental Payment Amount ' + getChangelogString(supplierOldData?.cardInfo?.mastercardIncrementalPaymentAmount, supplierNewData?.mastercardIncrementalPaymentAmount);
  }

  if (('isAcceptCardDiscount' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptCardDiscount !== supplierNewData?.isAcceptCardDiscount) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptCardDiscount)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptCardDiscount)
    changeLog += ', Accepts Discount by Card Payment updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptCardPaymentTerms' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptCardPaymentTerms !== supplierNewData?.isAcceptCardPaymentTerms) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptCardPaymentTerms)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptCardPaymentTerms)
    changeLog += ', Accepts Card Payment Terms updated from ' + oldReadableText + ' to ' + newReadableText;
  }

  if (('cardPaymentTermsvalue' in supplierNewData) && supplierNewData?.cardPaymentTermsvalue && supplierOldData?.cardInfo?.cardPaymentTermsvalue !== supplierNewData?.cardPaymentTermsvalue) {
    changeLog += ', Card Payment Terms Value ' + getChangelogString(supplierOldData?.cardInfo?.cardPaymentTermsvalue, supplierNewData?.cardPaymentTermsvalue);
  }
  if (('cardDiscountType' in supplierNewData) && supplierNewData?.cardDiscountType && supplierOldData?.cardInfo?.cardDiscountType !== supplierNewData?.cardDiscountType) {
    changeLog += ', Card Discount Type ' + getChangelogString(supplierOldData?.cardInfo?.cardDiscountType, supplierNewData?.cardDiscountType);
  }
  if (('cardDiscountValue' in supplierNewData) && supplierNewData?.cardDiscountValue && supplierOldData?.cardInfo?.cardDiscountValue !== supplierNewData?.cardDiscountValue) {
    changeLog += ', Card Discount Value ' + getChangelogString(supplierOldData?.cardInfo?.cardDiscountValue, supplierNewData?.cardDiscountValue);
  }
  if (('tokenType' in supplierNewData) && supplierNewData?.tokenType && supplierOldData?.cardInfo?.tokenType !== supplierNewData?.tokenType) {
    changeLog += ', Token Configuration ' + getChangelogString(supplierOldData?.cardInfo?.tokenType, supplierNewData?.tokenType);
  }
  if (('cardAuthorizationFormFile' in supplierNewData) && supplierNewData?.cardAuthorizationFormFile && supplierOldData?.cardInfo?.cardAuthorizationFormFile !== supplierNewData?.cardAuthorizationFormFile) {
    changeLog += ', Card Authorization Form file ' + getChangelogString(supplierOldData?.cardInfo?.cardAuthorizationFormFile, supplierNewData?.cardAuthorizationFormFile);
  }
  if (('isAcceptCardAuthorizationForm' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptCardAuthorizationForm !== supplierNewData?.isAcceptCardAuthorizationForm) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptCardAuthorizationForm)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptCardAuthorizationForm)
    changeLog += ', Accepts Card Autorization Form updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptCardPaymentByEmail' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptCardPaymentByEmail !== supplierNewData?.isAcceptCardPaymentByEmail) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptCardPaymentByEmail)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptCardPaymentByEmail)
    changeLog += ', Accepts Receive Payment by Email updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptCardPaymentByPhone' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptCardPaymentByPhone !== supplierNewData?.isAcceptCardPaymentByPhone) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptCardPaymentByPhone)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptCardPaymentByPhone)
    changeLog += ', Accepts Receive Payment by Phone updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptCardPaymentByFax' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptCardPaymentByFax !== supplierNewData?.isAcceptCardPaymentByFax) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptCardPaymentByFax)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptCardPaymentByFax)
    changeLog += ', Accepts Receive Payment by Fax updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptCardPaymentByOnlinePortal' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptCardPaymentByOnlinePortal !== supplierNewData?.isAcceptCardPaymentByOnlinePortal) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptCardPaymentByOnlinePortal)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptCardPaymentByOnlinePortal)
    changeLog += ', Accepts Receive Payment by Online Portal updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptPointOfSalePortal' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptPointOfSalePortal !== supplierNewData?.isAcceptPointOfSalePortal) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptPointOfSalePortal)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptPointOfSalePortal)
    changeLog += ', Accepts Receive Payment by Point of Sale updated from ' + oldReadableText + ' to ' + newReadableText;
  }

  if (('isAcceptEcommercePortal' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptEcommercePortal !== supplierNewData?.isAcceptEcommercePortal) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptEcommercePortal)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptEcommercePortal)
    changeLog += ', Accepts Receive Payment by E-Commerce updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptPortal' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptPortal !== supplierNewData?.isAcceptPortal) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptPortal)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptPortal)
    changeLog += ', Accepts Receive Payment by Portal updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAccept3rdPartyPortal' in supplierNewData) && supplierOldData?.cardInfo?.isAccept3rdPartyPortal !== supplierNewData?.isAccept3rdPartyPortal) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAccept3rdPartyPortal)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAccept3rdPartyPortal)
    changeLog += ', Accepts Receive Payment by 3rd Party Portal updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptInAppPortal' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptInAppPortal !== supplierNewData?.isAcceptInAppPortal) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptInAppPortal)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptInAppPortal)
    changeLog += ', Accepts Receive Payment by In-App updated from ' + oldReadableText + ' to ' + newReadableText;
  }

  if (('portalUrl' in supplierNewData) && (supplierNewData?.portalUrl || supplierOldData?.cardInfo?.portalUrl) && supplierOldData?.cardInfo?.portalUrl !== supplierNewData?.portalUrl) {
    changeLog += ', Portal URL ' + getChangelogString(supplierOldData?.cardInfo?.portalUrl, supplierNewData?.portalUrl);
  }
  if (('thirdPartyPortalUrl' in supplierNewData) && (supplierNewData?.thirdPartyPortalUrl || supplierOldData?.cardInfo?.thirdPartyPortalUrl) && supplierOldData?.cardInfo?.thirdPartyPortalUrl !== supplierNewData?.thirdPartyPortalUrl) {
    changeLog += ', Third Party Portal URL ' + getChangelogString(supplierOldData?.cardInfo?.thirdPartyPortalUrl, supplierNewData?.thirdPartyPortalUrl);
  }

  if (('cardPaymentByPhoneValue' in supplierNewData) && (supplierNewData?.cardPaymentByPhoneValue || supplierOldData?.cardInfo?.cardPaymentByPhoneValue) && supplierOldData?.cardInfo?.cardPaymentByPhoneValue?.toString()?.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '')?.replace(/[^\w\s]|[\s]/gi, '') !== supplierNewData?.cardPaymentByPhoneValue?.toString()?.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '')?.replace(/[^\w\s]|[\s]/gi, '')) {
    changeLog += ', Card Payment Phone ' + getChangelogString(supplierOldData?.cardInfo?.cardPaymentByPhoneValue, supplierNewData?.cardPaymentByPhoneValue);
  }
  if (('cardPaymentIVRPhone' in supplierNewData) && (supplierNewData?.cardPaymentIVRPhone || supplierOldData?.cardInfo?.cardPaymentIVRPhone) && supplierOldData?.cardInfo?.cardPaymentIVRPhone?.toString()?.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '')?.replace(/[^\w\s]|[\s]/gi, '') !== supplierNewData?.cardPaymentIVRPhone?.toString()?.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '')?.replace(/[^\w\s]|[\s]/gi, '')) {
    changeLog += ', Card Payment Phone ' + getChangelogString(supplierOldData?.cardInfo?.cardPaymentIVRPhone, supplierNewData?.cardPaymentIVRPhone);
  }
  if (('cardPaymentByFaxValue' in supplierNewData) && (supplierNewData?.cardPaymentByFaxValue || supplierOldData?.cardInfo?.cardPaymentByFaxValue) && supplierOldData?.cardInfo?.cardPaymentByFaxValue !== supplierNewData?.cardPaymentByFaxValue) {
    changeLog += ', Card Payment Fax ' + getChangelogString(supplierOldData?.cardInfo?.cardPaymentByFaxValue, supplierNewData?.cardPaymentByFaxValue);
  }

  if (Object.keys(addEmailValues).length > 0) {
    changeLog += ', Card Acceptance ' + (Object.keys(addEmailValues).length === 1 ? 'email' : 'emails') + ' added: ' + Object.values(addEmailValues).toString();
  }
  if (Object.keys(removeEmailValues).length > 0) {
    changeLog += ', Card Acceptance ' + (Object.keys(removeEmailValues).length === 1 ? 'email' : 'emails') + ' removed: ' + Object.values(removeEmailValues).toString();
  }
  if (('isAcceptProductSpecific' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptProductSpecific !== supplierNewData?.isAcceptProductSpecific) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptProductSpecific)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptProductSpecific)
    changeLog += ', Accepts Product Specific updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('productSpecificOptions' in supplierNewData) && (supplierNewData?.productSpecificOptions || supplierOldData?.cardInfo?.productSpecificOptions) && supplierOldData?.cardInfo?.productSpecificOptions !== supplierNewData?.productSpecificOptions) {
    changeLog += ', Product Specific Options ' + getChangelogString(supplierOldData?.cardInfo?.productSpecificOptions, supplierNewData?.productSpecificOptions);
  }
  if (('emailRemitRequirements' in supplierNewData) && (supplierNewData?.emailRemitRequirements || supplierOldData?.cardInfo?.emailRemitRequirements) && supplierOldData?.cardInfo?.emailRemitRequirements !== supplierNewData?.emailRemitRequirements) {
    changeLog += ', Email Requirements ' + getChangelogString(supplierOldData?.cardInfo?.emailRemitRequirements, supplierNewData?.emailRemitRequirements);
  }
  if (('phoneRemitRequirements' in supplierNewData) && (supplierNewData?.phoneRemitRequirements || supplierOldData?.cardInfo?.phoneRemitRequirements) && supplierOldData?.cardInfo?.phoneRemitRequirements !== supplierNewData?.phoneRemitRequirements) {
    changeLog += ', Phone Requirements ' + getChangelogString(supplierOldData?.cardInfo?.phoneRemitRequirements, supplierNewData?.phoneRemitRequirements);
  }
  if (('faxRemitRequirements' in supplierNewData) && (supplierNewData?.faxRemitRequirements || supplierOldData?.cardInfo?.faxRemitRequirements) && supplierOldData?.cardInfo?.faxRemitRequirements !== supplierNewData?.faxRemitRequirements) {
    changeLog += ', Fax Requirements ' + getChangelogString(supplierOldData?.cardInfo?.faxRemitRequirements, supplierNewData?.faxRemitRequirements);
  }
  if (('onlineRemitRequirements' in supplierNewData) && (supplierNewData?.onlineRemitRequirements || supplierOldData?.cardInfo?.onlineRemitRequirements) && supplierOldData?.cardInfo?.onlineRemitRequirements !== supplierNewData?.onlineRemitRequirements) {
    changeLog += ', Online Requirements ' + getChangelogString(supplierOldData?.cardInfo?.onlineRemitRequirements, supplierNewData?.onlineRemitRequirements);
  }
  if (('posRemitRequirements' in supplierNewData) && (supplierNewData?.posRemitRequirements || supplierOldData?.cardInfo?.posRemitRequirements) && supplierOldData?.cardInfo?.posRemitRequirements !== supplierNewData?.posRemitRequirements) {
    changeLog += ', POS Requirements ' + getChangelogString(supplierOldData?.cardInfo?.posRemitRequirements, supplierNewData?.posRemitRequirements);
  }

  if (('isAcceptAmexCardConditions' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptAmexCardConditions !== supplierNewData?.isAcceptAmexCardConditions) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptAmexCardConditions)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptAmexCardConditions)
    changeLog += ', Accepts AMEX Conditions updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptVisaCardConditions' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptVisaCardConditions !== supplierNewData?.isAcceptVisaCardConditions) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptVisaCardConditions)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptVisaCardConditions)
    changeLog += ', Accepts Visa Conditions updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptMastercardCardConditions' in supplierNewData) && supplierOldData?.cardInfo?.isAcceptMastercardCardConditions !== supplierNewData?.isAcceptMastercardCardConditions) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.cardInfo?.isAcceptMastercardCardConditions)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptMastercardCardConditions)
    changeLog += ', Accepts Mastercard Conditions updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  return changeLog.replace(/(^, )|(, $)/g, '');
}

// to get Supplier Check Acceptance Change Log
export const generateCheckAcceptanceChangeLog = (supplierOldData, supplierNewData) => {
  let changeLog = '';
  let oldReadableText = ''
  let newReadableText = ''
  if (('isAcceptCheckPayments' in supplierNewData) && supplierOldData?.paymentInfo?.isAcceptCheckPayments !== supplierNewData?.isAcceptCheckPayments) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.paymentInfo?.isAcceptCheckPayments)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptCheckPayments)
    changeLog += 'Accepts Check Payments updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptPaymentAddressFromCompanyAddress' in supplierNewData) && supplierOldData?.paymentInfo?.isAcceptPaymentAddressFromCompanyAddress !== supplierNewData?.isAcceptPaymentAddressFromCompanyAddress) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.paymentInfo?.isAcceptPaymentAddressFromCompanyAddress)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptPaymentAddressFromCompanyAddress)
    changeLog += ', Check Payment Address updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptCashPaymentTerms' in supplierNewData) && supplierOldData?.paymentInfo?.isAcceptCashPaymentTerms !== supplierNewData?.isAcceptCashPaymentTerms) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.paymentInfo?.isAcceptCashPaymentTerms)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptCashPaymentTerms)
    changeLog += ', Accepts Cash Payment Terms updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('isAcceptCashDiscount' in supplierNewData) && supplierOldData?.paymentInfo?.isAcceptCashDiscount !== supplierNewData?.isAcceptCashDiscount) {
    oldReadableText = getReadableTextForChangelog(supplierOldData?.paymentInfo?.isAcceptCashDiscount)
    newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptCashDiscount)
    changeLog += ', Accepts Cash Discount updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('cashPaymentTermsValue' in supplierNewData) && supplierNewData?.cashPaymentTermsValue && supplierOldData?.paymentInfo?.cashPaymentTermsValue !== supplierNewData?.cashPaymentTermsValue) {
    changeLog += ', Cash Payment Terms Value ' + getChangelogString(supplierOldData?.paymentInfo?.cashPaymentTermsValue, supplierNewData?.cashPaymentTermsValue);
  }
  if (('cashDiscountType' in supplierNewData) && supplierNewData?.cashDiscountType && supplierOldData?.paymentInfo?.cashDiscountType !== supplierNewData?.cashDiscountType) {
    changeLog += ', Cash Discount Type ' + getChangelogString(supplierOldData?.paymentInfo?.cashDiscountType, supplierNewData?.cashDiscountType);
  }
  if (('cashDiscountValue' in supplierNewData) && (supplierNewData?.cashDiscountValue || supplierOldData?.paymentInfo?.cashDiscountValue) && supplierOldData?.paymentInfo?.cashDiscountValue !== supplierNewData?.cashDiscountValue) {
    changeLog += ', Cash Discount Value ' + getChangelogString(supplierOldData?.paymentInfo?.cashDiscountValue, supplierNewData?.cashDiscountValue);
  }

  if (('checkAddress1' in supplierNewData) && (supplierNewData?.checkAddress1 || supplierOldData?.paymentInfo?.checkAddress1) && supplierOldData?.paymentInfo?.checkAddress1 !== supplierNewData?.checkAddress1) {
    changeLog += ', Check Address1 ' + getChangelogString(supplierOldData?.paymentInfo?.checkAddress1, supplierNewData?.checkAddress1);
  }
  if (('checkAddress2' in supplierNewData) && (supplierNewData?.checkAddress2 || supplierOldData?.paymentInfo?.checkAddress2) && supplierOldData?.paymentInfo?.checkAddress2 !== supplierNewData?.checkAddress2) {
    changeLog += ', Check Address2 ' + getChangelogString(supplierOldData?.paymentInfo?.checkAddress2, supplierNewData?.checkAddress2);
  }
  if (('checkCity' in supplierNewData) && (supplierNewData?.checkCity || supplierOldData?.paymentInfo?.checkCity) && supplierOldData?.paymentInfo?.checkCity !== supplierNewData?.checkCity) {
    changeLog += ', Check City ' + getChangelogString(supplierOldData?.paymentInfo?.checkCity, supplierNewData?.checkCity);
  }
  if (('checkState' in supplierNewData) && (supplierNewData?.checkState || supplierOldData?.paymentInfo?.checkState) && supplierOldData?.paymentInfo?.checkState !== supplierNewData?.checkState) {
    changeLog += ', Check State ' + getChangelogString(supplierOldData?.paymentInfo?.checkState, supplierNewData?.checkState);
  }
  if (('checkZip' in supplierNewData) && (supplierNewData?.checkZip || supplierOldData?.paymentInfo?.checkZip) && supplierOldData?.paymentInfo?.checkZip !== supplierNewData?.checkZip) {
    changeLog += ', Check Zip ' + getChangelogString(supplierOldData?.paymentInfo?.checkZip, supplierNewData?.checkZip);
  }
  if (('checkCountry' in supplierNewData) && (supplierNewData?.checkCountry || supplierOldData?.paymentInfo?.checkCountry) && supplierOldData?.paymentInfo?.checkCountry !== supplierNewData?.checkCountry) {
    changeLog += ', Check Country ' + getChangelogString(supplierOldData?.paymentInfo?.checkCountry, supplierNewData?.checkCountry);
  }
  return changeLog.replace(/(^, )|(, $)/g, '');
}

// to get Supplier Ach Acceptance Change Log
export const generateAchAcceptanceChangeLog = (supplierOldData, supplierNewData) => {
  var changeLog = '';
  if (('isAcceptAchPayments' in supplierNewData) && supplierOldData?.paymentInfo?.isAcceptAchPayments !== supplierNewData?.isAcceptAchPayments) {
    var oldReadableText = getReadableTextForChangelog(supplierOldData?.paymentInfo?.isAcceptAchPayments)
    var newReadableText = getReadableTextForChangelog(supplierNewData?.isAcceptAchPayments)
    changeLog += 'Accepts ACH Payments updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('bankName' in supplierNewData) && (supplierNewData?.bankName || supplierOldData?.paymentInfo?.bankName) && supplierOldData?.paymentInfo?.bankName !== supplierNewData?.bankName) {
    changeLog += ', Bank Name ' + getChangelogString(supplierOldData?.paymentInfo?.bankName, supplierNewData?.bankName);
  }
  if (('bankAccountNumber' in supplierNewData) && (supplierNewData?.bankAccountNumber || supplierOldData?.paymentInfo?.bankAccountNumber) && supplierOldData?.paymentInfo?.bankAccountNumber !== supplierNewData?.bankAccountNumber) {
    changeLog += ', Bank Account Number ' + getChangelogString(supplierOldData?.paymentInfo?.bankAccountNumber, supplierNewData?.bankAccountNumber);
  }
  if (('bankRoutingNumber' in supplierNewData) && (supplierNewData?.bankRoutingNumber || supplierOldData?.paymentInfo?.bankRoutingNumber) && supplierOldData?.paymentInfo?.bankRoutingNumber !== supplierNewData?.bankRoutingNumber) {
    changeLog += ', Bank Routing Number ' + getChangelogString(supplierOldData?.paymentInfo?.bankRoutingNumber, supplierNewData?.bankRoutingNumber);
  }
  if (('emailAch' in supplierNewData) && (supplierNewData?.emailAch || supplierOldData?.paymentInfo?.emailAch) && supplierOldData?.paymentInfo?.emailAch !== supplierNewData?.emailAch) {
    changeLog += ', Email Address for payment notification ' + getChangelogString(supplierOldData?.paymentInfo?.emailAch, supplierNewData?.emailAch);
  }
  if (('achInstructions' in supplierNewData) && supplierNewData?.achInstructions && supplierOldData?.paymentInfo?.achInstructions !== supplierNewData?.achInstructions) {
    changeLog += ', ACH Instructions file ' + getChangelogString(supplierOldData?.paymentInfo?.achInstructions, supplierNewData?.achInstructions);
  }
  if (('isAchThroughPortal' in supplierNewData) && supplierOldData?.paymentInfo?.isAchThroughPortal !== supplierNewData?.isAchThroughPortal) {
    let oldReadableText = getReadableTextForChangelog(supplierOldData?.paymentInfo?.isAchThroughPortal)
    let newReadableText = getReadableTextForChangelog(supplierNewData?.isAchThroughPortal)
    changeLog += ', Accepts ACH Through Portal updated from ' + oldReadableText + ' to ' + newReadableText;
  }
  if (('achPortalURL' in supplierNewData) && (supplierNewData?.achPortalURL || supplierOldData?.paymentInfo?.achPortalURL) && supplierOldData?.paymentInfo?.achPortalURL !== supplierNewData?.achPortalURL) {
    changeLog += ', ACH Portal URL ' + getChangelogString(supplierOldData?.paymentInfo?.achPortalURL, supplierNewData?.achPortalURL);
  }
  return changeLog.replace(/(^, )|(, $)/g, '');
}

// to get changelog text for boolean values
export const getReadableTextForChangelog = (value) => {
  if (value === null || value === undefined || value === '') {
    return 'Unknown'
  } else if (value === true) {
    return 'Yes'
  } else if (value === false) {
    return 'No'
  } else {
    return value
  }
}

// to get changelog text on basis of Old and new value
const getChangelogString = (oldValue, newValue) => {
  var changelogString = ''
  if (oldValue && !newValue) {
    return 'value <b>' + oldValue + '</b> removed'
  }

  changelogString = 'updated' + (oldValue ? ' from ' + oldValue : '') + ' to ' + newValue;
  return changelogString;
}


export const splitArrayInToChunks = (arrayToSplit, chunkSize) => {
  var arrayChunks = [];
  while (arrayToSplit.length) {
    arrayChunks.push(arrayToSplit.splice(0, chunkSize));
  }
  return arrayChunks;
}

export function findDuplicateEmails(input) {
  var values = {}, key;
  var duplicateEmails = false;

  for (key in input) {
    if (input.hasOwnProperty(key)) {
      values[input[key]?.email] = values.hasOwnProperty(input[key]?.email) ? values[input[key]?.email] + 1 : 1;
      if (values?.[input[key]?.email] > 1) {
        delete input[key];
      }
    }
  }

  for (key in values) {
    if (values.hasOwnProperty(key) && values[key] > 1) {
      duplicateEmails = true
      break;
    }
  }
  return {
    'isDuplicateEmail': duplicateEmails,
    'addedEmails': input
  }
}

export const checkIsPhoneNumberValid = async (phoneValue, phoneValueWithCode, dispatch, isRetry = false) => {
  var isPhoneValid = '';
  var isValidatingPhone = false;
  var phoneNumber = phoneValueWithCode
  await dispatch(
    checkEmailPhoneLastValidatedDate({
      valueToValidate: phoneValue,
      valueType: 'phone'
    })
  ).then(async (res) => {
    if (res.length === 0) {
      await dispatch(
        validatePhoneValue({
          valueToValidate: phoneValueWithCode
        })
      ).then(async (result) => {
        if (result?.valid) {
          isPhoneValid = true
          phoneNumber = result?.international_format.replace(/^\s*(?:\+?)/, '')
        } else {
          isPhoneValid = false
          toast.show({
            title: 'Warning',
            description: 'Please enter valid phone number!',
          })
        }
        isValidatingPhone = false
        await dispatch(
          saveEmailOrPhoneValidatedData({
            valueToValidate: phoneValue,
            valueType: 'phone',
            isValid: isPhoneValid
          })
        )
      }).catch(error => {
        console.log('validateEmailOrPhoneValueError', error)
      })
    }
    if (res.length > 0) {
      if (isRetry) {
        await dispatch(
          validatePhoneValue({
            valueToValidate: phoneValueWithCode
          })
        ).then(async (result) => {
          if (result?.valid) {
            isPhoneValid = true
            phoneNumber = result?.international_format.replace(/^\s*(?:\+?)/, '')
          } else {
            isPhoneValid = false
            toast.show({
              title: 'Warning',
              description: 'Please enter valid phone number!',
            })
          }
          isValidatingPhone = false
          await dispatch(
            updateEmailOrPhoneValidatedData({
              valueToValidate: phoneValue,
              valueType: 'phone',
              isValid: isPhoneValid
            })
          )
        }).catch(error => {
          console.log('validateEmailOrPhoneValueError', error)
        })
      } else {
        const lastValidatedDateObject = new Date(res?.[0].lastValidatedDate);
        const currentDateObject = new Date();
        const day = (lastValidatedDateObject.getDate() < 10) ? '0' + lastValidatedDateObject.getDate() : lastValidatedDateObject.getDate();
        const month = (lastValidatedDateObject.getMonth() < 10) ? '0' + (lastValidatedDateObject.getMonth() + 1) : (lastValidatedDateObject.getMonth() + 1);
        const year = lastValidatedDateObject.getFullYear();

        const lastValidatedfullDate = year + '-' + month + '-' + day;
        var dateBeforeSixMonth = currentDateObject.setMonth((currentDateObject.getMonth() - 6));
        dateBeforeSixMonth = new Date(dateBeforeSixMonth)
        const currentDay = (dateBeforeSixMonth.getDate() < 10) ? '0' + dateBeforeSixMonth.getDate() : dateBeforeSixMonth.getDate();
        const currentMonth = (dateBeforeSixMonth.getMonth() < 10) ? '0' + (dateBeforeSixMonth.getMonth() + 1) : (dateBeforeSixMonth.getMonth() + 1);
        const currentYear = dateBeforeSixMonth.getFullYear();
        const fullDateBeforeSixMonth = currentYear + '-' + currentMonth + '-' + currentDay;

        if (new Date(lastValidatedfullDate).getTime() < new Date(fullDateBeforeSixMonth).getTime()) {
          await dispatch(
            validatePhoneValue({
              valueToValidate: phoneValueWithCode
            })
          ).then(async (result) => {
            if (result?.valid) {
              isPhoneValid = true
              phoneNumber = result?.international_format.replace(/^\s*(?:\+?)/, '')
            } else {
              isPhoneValid = false
              toast.show({
                title: 'Warning',
                description: 'Please enter valid phone number!',
              })
            }
            isValidatingPhone = false
            await dispatch(
              updateEmailOrPhoneValidatedData({
                valueToValidate: phoneValue,
                valueType: 'phone',
                isValid: isPhoneValid
              })
            )
          }).catch(error => {
            console.log('validateEmailOrPhoneValueError', error)
          })
        } else {
          isPhoneValid = res?.[0].isValid
          isValidatingPhone = false
        }
      }
    }
  }).catch(err => {
    console.log('valueToValidateResultError', err)
  })

  return {
    isPhoneValid,
    isValidatingPhone,
    phoneNumber
  }
}

// To validate the Email Value
export const checkIsEmailValid = async (emailValue, dispatch, isRetry = false) => {

  var isEmailValid = '';
  let isEmailRisky = "";
  var isValidatingEmail = false;
  await dispatch(
    checkEmailPhoneLastValidatedDate({
      valueToValidate: emailValue,
      valueType: 'email'
    })
  ).then(async (res) => {
    if (res.length === 0) {
      await dispatch(
        validateEmailValue({
          valueToValidate: emailValue
        })
      ).then(async (result) => {
        if (result?.status === 'valid' || result?.status === 'catch-all') {
          isEmailValid = true;
          isEmailRisky = false;
        } else if (result?.status === 'do_not_mail') {
          isEmailValid = true;
          isEmailRisky = true;
        }
        else {
          isEmailValid = false;
          isEmailRisky = false
          toast.show({
            title: 'Warning',
            description: 'Please enter valid email!',
          })
        }
        isValidatingEmail = false
        await dispatch(
          saveEmailOrPhoneValidatedData({
            valueToValidate: emailValue,
            valueType: 'email',
            isValid: isEmailValid,
            isEmailRisky
          })
        )
      }).catch(error => {
        console.log('validateEmailOrPhoneValueError', error)
      })
    }
    if (res.length > 0) {
      if (isRetry) {
        await dispatch(
          validateEmailValue({
            valueToValidate: emailValue
          })
        ).then(async (result) => {
          if (result?.status === 'valid' || result?.status === 'catch-all') {
            isEmailValid = true
            isEmailRisky = false
          } else if (result?.status === 'do_not_mail') {
            isEmailValid = true
            isEmailRisky = true
          } else {
            isEmailValid = false
            isEmailRisky = false
            toast.show({
              title: 'Warning',
              description: 'Please enter valid email!',
            })
          }
          isValidatingEmail = false
          await dispatch(
            updateEmailOrPhoneValidatedData({
              valueToValidate: emailValue,
              valueType: 'email',
              isValid: isEmailValid,
              isEmailRisky
            })
          )
        }).catch(error => {
          console.log('validateEmailOrPhoneValueError', error)
        })
      } else {
        const lastValidatedDateObject = new Date(res?.[0].lastValidatedDate);
        const currentDateObject = new Date();
        const day = (lastValidatedDateObject.getDate() < 10) ? '0' + lastValidatedDateObject.getDate() : lastValidatedDateObject.getDate();
        const month = (lastValidatedDateObject.getMonth() < 10) ? '0' + (lastValidatedDateObject.getMonth() + 1) : (lastValidatedDateObject.getMonth() + 1);
        const year = lastValidatedDateObject.getFullYear();

        const lastValidatedfullDate = year + '-' + month + '-' + day;
        var dateBeforeSixMonth = currentDateObject.setMonth((currentDateObject.getMonth() - 6));
        dateBeforeSixMonth = new Date(dateBeforeSixMonth)
        const currentDay = (dateBeforeSixMonth.getDate() < 10) ? '0' + dateBeforeSixMonth.getDate() : dateBeforeSixMonth.getDate();
        const currentMonth = (dateBeforeSixMonth.getMonth() < 10) ? '0' + (dateBeforeSixMonth.getMonth() + 1) : (dateBeforeSixMonth.getMonth() + 1);
        const currentYear = dateBeforeSixMonth.getFullYear();
        const fullDateBeforeSixMonth = currentYear + '-' + currentMonth + '-' + currentDay;

        if (new Date(lastValidatedfullDate).getTime() < new Date(fullDateBeforeSixMonth).getTime()) {
          await dispatch(
            validateEmailValue({
              valueToValidate: emailValue
            })
          ).then(async (result) => {
            if (result?.status === 'valid' || result?.status === 'catch-all') {
              isEmailValid = true
              isEmailRisky = false
            } else if (result?.status === 'do_not_mail') {
              isEmailValid = true
              isEmailRisky = true
            }
            else {
              isEmailValid = false
              isEmailRisky = false
              toast.show({
                title: 'Warning',
                description: 'Please enter valid email!',
              })
            }
            isValidatingEmail = false
            await dispatch(
              updateEmailOrPhoneValidatedData({
                valueToValidate: emailValue,
                valueType: 'email',
                isValid: isEmailValid,
                isEmailRisky
              })
            )
          }).catch(error => {
            console.log('validateEmailOrPhoneValueError', error)
          })
        } else {
          isEmailValid = res?.[0].isValid
          isValidatingEmail = false
          isEmailRisky = res?.[0].isEmailRisky
        }
      }
    }
  }).catch(err => {
    console.log('valueToValidateResultError', err)
  })

  return {
    isEmailValid,
    isValidatingEmail,
    isEmailRisky
  }
}

export const capitalizeFirstCharacter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// get the abbreviated state from State Name
export const getAbbreviatedState = (abbreviatedState, state) => {
  let stateCode = ''
  if (abbreviatedState) {
    stateCode = abbreviatedState
  } else {
    let stateCodeKey = state && state.trim().length > 3 && Object.keys(stateCodesList).find(stateKey => stateKey.toLowerCase() === state.trim().toLowerCase());
    stateCode = stateCodeKey ? stateCodesList[stateCodeKey]?.['abbr'] : state ? state.trim() : state;
  }

  return stateCode;
}

// add days to Date by excluding Saturday and Sunday
export const addBusinessDays = (originalDate, numDaysToAdd) => {
  const sunday = 0;
  const saturday = 6;
  let daysRemaining = numDaysToAdd;
  const newDate = originalDate.clone()

  while (daysRemaining > 0) {
    newDate.add(1, 'days');
    if (newDate.day() !== sunday && newDate.day() !== saturday) {
      daysRemaining--;
    }
  }
  return newDate;
}

// to get the card fee data for Import Workflow if generic fee column is mapped
export const getCardGenericFeeDataForImport = (cardData, rowData, colName, genericDollarFeeCol, genericPercentFeeCol, amexFeeTypeCol, visaFeeTypeCol, masterFeeTypeCol) => {
  if (rowData[genericDollarFeeCol] && rowData[genericDollarFeeCol] !== '') {
    let value = getFeeValue(rowData[genericDollarFeeCol])
    cardData[colName] = value
    cardData[amexFeeTypeCol] = cardData[visaFeeTypeCol] = cardData[masterFeeTypeCol] = '$'
  }
  if (rowData[genericPercentFeeCol] && rowData[genericPercentFeeCol] !== '') {
    let value = getFeeValue(rowData[genericPercentFeeCol])
    cardData[colName] = value
    cardData[amexFeeTypeCol] = cardData[visaFeeTypeCol] = cardData[masterFeeTypeCol] = '%'
  }
  return cardData
}

// to get the card fee data for Import Workflow if card specific fee columns are mapped
export const getCardSpecificFeeDataForImport = (cardData, rowData, cardFeeCols, colName, amexDollarFeeCol, amexPercentFeeCol, visaDollarFeeCol, visaPercentFeeCol, masterDollarFeeCol, masterPercentFeeCol, amexFeeTypeCol, visaFeeTypeCol, masterFeeTypeCol) => {
  if (colName === cardFeeCols[0]) {
    if (rowData[amexDollarFeeCol] && rowData[amexDollarFeeCol] !== '') {
      let value = getFeeValue(rowData[amexDollarFeeCol])
      cardData[colName] = value
      cardData[amexFeeTypeCol] = '$'
    }
    if (rowData[amexPercentFeeCol] && rowData[amexPercentFeeCol] !== '') {
      let value = getFeeValue(rowData[amexPercentFeeCol])
      cardData[colName] = value
      cardData[amexFeeTypeCol] = '%'
    }
  }
  if (colName === cardFeeCols[1]) {
    if (rowData[visaDollarFeeCol] && rowData[visaDollarFeeCol] !== '') {
      let value = getFeeValue(rowData[visaDollarFeeCol])
      cardData[colName] = value
      cardData[visaFeeTypeCol] = '$'
    }
    if (rowData[visaPercentFeeCol] && rowData[visaPercentFeeCol] !== '') {
      let value = getFeeValue(rowData[visaPercentFeeCol])
      cardData[colName] = value
      cardData[visaFeeTypeCol] = '%'
    }
  }
  if (colName === cardFeeCols[2]) {
    if (rowData[masterDollarFeeCol] && rowData[masterDollarFeeCol] !== '') {
      let value = getFeeValue(rowData[masterDollarFeeCol])
      cardData[colName] = value
      cardData[masterFeeTypeCol] = '$'
    }
    if (rowData[masterPercentFeeCol] && rowData[masterPercentFeeCol] !== '') {
      let value = getFeeValue(rowData[masterPercentFeeCol])
      cardData[colName] = value
      cardData[masterFeeTypeCol] = '%'
    }
  }
  return cardData
}

export const getFeeValue = (value) => {
  let temp = "";
  temp = value ? parseInt(value.replace(/\D/g, '')) : '';
  value = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
  return value
}

// get the state name from Abbreviated State Name
export const getStateName = (abbreviatedState) => {
  let stateName = ''
  if (abbreviatedState) {
    stateName = Object.entries(stateCodesList).find(stateVal => stateVal?.[1]?.['abbr'].toLowerCase() === abbreviatedState.trim().toLowerCase());
    stateName = stateName ? stateName?.[0] : ''
  }
  return stateName;
}

export const checkIsAdminOrModerator = (currentDomain) => {
  var isAdminOrModerator = false
  if ((currentDomain?.roleId === 3 || currentDomain?.roleName === 'admin') || (currentDomain?.roleId === 2 || currentDomain?.roleName === 'moderator')) {
    isAdminOrModerator = true
  }
  return isAdminOrModerator
}

export const checkIsAdmin = (currentDomain) => {
  var isAdmin = false
  if (currentDomain?.roleId === 3 || currentDomain?.roleName === 'admin') {
    isAdmin = true
  }
  return isAdmin
}

export const chechIsStateValid = (state) => {
  let isState = Object.entries(stateCodesList).find(stateVal => (stateVal?.[0].toLowerCase() === state.toString().trim().toLowerCase() || stateVal?.[1]?.['abbr'].toLowerCase() === state.toString().trim().toLowerCase()));
  if (isState) {
    return true
  } else {
    return false
  }
}

// convert blob url to Data URL
export const blobToDataUrl = async (blob) => {
  return new Promise(r => { let reader = new FileReader(); reader.onload = r; reader.readAsDataURL(blob) }).then(e => { return e.target.result });
}

export const createTwilioDevice = async (user, dispatch) => {
  var userName = user?.firstname + (user?.lastname ? '' + user?.lastname : '')
  var assignedPhoneNumber = user?.assignedPhoneNumber
  var isCaller = user?.isCaller
  const Device = (await import('twilio-client')).Device
  let device = new Device();
  let token = await generateToken(userName, assignedPhoneNumber, isCaller, dispatch)
  dispatch({
    type: CREATE_TWILIO_TOKEN,
    data: token
  })
  dispatch({
    type: CREATE_TWILIO_DEVICE,
    data: device
  })
  await device.setup(token, {
    // allowIncomingWhileBusy: true,
    enableRingingState: true,
    debug: true,
    codecPreferences: ['opus', 'pcmu'],
  });
  device.on('ready', () => {
    console.log("Twilio ready");
    device.identity = userName;
    console.log("Twilio Device ", device);
  })
  // device.on('error', (error) => {
  //   toast.show({
  //     title: 'Warning',
  //     description: error.message,
  //   })
  //   console.log("\n\n error in twilio \n\n", error);
  //   if (error.message == "JWT Token Expired") {
  //     // alert("token expired");
  //     createTwilioDevice(user, dispatch)
  //   }
  // })

  //For some reason returning the device and then using it doesn't work
  //So keep all the "device.on()" stuff inside the async function
  return device
}

export const destroyTwilioDevice = async (device, dispatch) => {
  if (device) {
    await device.destroy();
    dispatch({
      type: CREATE_TWILIO_DEVICE,
      data: null
    })
  }
}

export const generateToken = async (userName, assignedPhoneNumber, isCaller, dispatch) => {
  const token = await dispatch(getAccessToken(userName, assignedPhoneNumber, isCaller)).then(res => {
    return res
  }).catch(err => {
    console.log('err', err)
  })
  return token
}

export const getTimezoneByState = (state, supplierZipCode) => {
  const timezones = ['AEST', 'ACST', 'AWST', 'AST', 'NST', 'EST', 'CST', 'MST', 'PST', 'AKST', 'HST', 'CET']

  let tmz = ''
  let results = Object?.values(stateCodesList)?.filter((stateValues) => {
    if (stateValues?.abbr?.toLowerCase() === state?.toLowerCase()) {
      return stateValues
    }
  })

  if (results.length > 1) {
    const uniqueTimeZones = new Set(results.map(item => item.tz));
    if (uniqueTimeZones.size > 1) {
      results?.forEach((result) => {
        let tmptz = timezones.filter((tz) => tz === result?.tz)[0]
        tmz = tmptz || ''

      })
    } else {
      tmz = results[0]?.tz

    }
  } else {
    tmz = results.length === 0 ? '' : results[0]?.tz
  }
  // console.log("tmz", tmz)
  return tmz ? tmz.trim() : ''

}

//contact date, 18
//check given date is older than given timespan in months
export const checkDateDiff = (dateToCheck, timeSpan) => {
  const lastDateObject = dateToCheck;
  const currentDateObject = new Date();
  const day = (lastDateObject.getDate() < 10) ? '0' + lastDateObject.getDate() : lastDateObject.getDate();
  const month = (lastDateObject.getMonth() < 10) ? '0' + (lastDateObject.getMonth() + 1) : (lastDateObject.getMonth() + 1);
  const year = lastDateObject.getFullYear();

  const lastfullDate = year + '-' + month + '-' + day;
  var dateBeforeTimespan = currentDateObject.setMonth((currentDateObject.getMonth() - timeSpan));
  dateBeforeTimespan = new Date(dateBeforeTimespan)
  const currentDay = (dateBeforeTimespan.getDate() < 10) ? '0' + dateBeforeTimespan.getDate() : dateBeforeTimespan.getDate();
  const currentMonth = (dateBeforeTimespan.getMonth() < 10) ? '0' + (dateBeforeTimespan.getMonth() + 1) : (dateBeforeTimespan.getMonth() + 1);
  const currentYear = dateBeforeTimespan.getFullYear();
  const fullDateBeforeTimespan = currentYear + '-' + currentMonth + '-' + currentDay;
  if (new Date(lastfullDate).getTime() <= new Date(fullDateBeforeTimespan).getTime()) {
    return true
  } else {
    return false
  }
}

export const checkCalledDateDiff = (lastCalledDate, timeSpan) => {
  const cutoffDate = new Date();
  cutoffDate.setMonth(cutoffDate.getMonth() - 18);

  if (lastCalledDate < cutoffDate) {
    return true
  } else {
    return false
  }
}

export const updateReportFeesColumn = (response, isCardAcceptanceHeaderSelected, isAcceptanceFilterApplied, isCcRemittanceFilterApplied, isCcPaymentFilterApplied, isCcRemittanceColChecked, isCcPaymentColChecked, IsPayFilterApplied, isPayColChecked) => {
  let newResult = response.data.map((col) => {
    if (col['firstname']) {
      col['Added By User'] = (col['firstname'] === undefined || col['firstname'] === undefined) || (col['firstname'] === null || col['firstname'] === null) ? null : col?.firstname + " " + col?.lastname
    }
    if (isCardAcceptanceHeaderSelected || isAcceptanceFilterApplied) {
      col['amexIncrementalFee'] = col?.amexIncrementalFeeValue === '' || col?.amexIncrementalFeeValue === null || col?.amexIncrementalFeeValue === undefined ? '' : col?.amexIncrementalFeeType === '$' ? `$${col?.amexIncrementalFeeValue}` : `${col?.amexIncrementalFeeValue}%`
      col['amexMaxPaymentFee'] = col?.amexMaxPaymentFeeValue === '' || col?.amexMaxPaymentFeeValue === null || col?.amexMaxPaymentFeeValue === undefined ? '' : col?.amexMaxPaymentFeeType === '$' ? `$${col?.amexMaxPaymentFeeValue}` : `${col?.amexMaxPaymentFeeValue}%`
      col['amexMinPaymentFee'] = col?.amexMinPaymentFeeValue === '' || col?.amexMinPaymentFeeValue === null || col?.amexMinPaymentFeeValue === undefined ? '' : col?.amexMinPaymentFeeType === '$' ? `$${col?.amexMinPaymentFeeValue}` : `${col?.amexMinPaymentFeeValue}%`
      col['amexProcessingFee'] = col?.amexProcessingFeeValue === '' || col?.amexProcessingFeeValue === null || col?.amexProcessingFeeValue === undefined ? '' : col?.amexProcessingFeeType === '$' ? `$${col?.amexProcessingFeeValue}` : `${col?.amexProcessingFeeValue}%`
      col['amexSecondProcessingFee'] = col?.amexSecondProcessingFeeValue === '' || col?.amexSecondProcessingFeeValue === null || col?.amexSecondProcessingFeeValue === undefined ? '' : col?.amexSecondProcessingFeeType === '$' ? `$${col?.amexSecondProcessingFeeValue}` : `${col?.amexSecondProcessingFeeValue}%`

      col['mastercardIncrementalFee'] = col?.mastercardIncrementalFeeValue === '' || col?.mastercardIncrementalFeeValue === null || col?.mastercardIncrementalFeeValue === undefined ? '' : col?.mastercardIncrementalFeeType === '$' ? `$${col?.mastercardIncrementalFeeValue}` : `${col?.mastercardIncrementalFeeValue}%`
      col['mastercardMaxPaymentFee'] = col?.mastercardMaxPaymentFeeValue === '' || col?.mastercardMaxPaymentFeeValue === null || col?.mastercardMaxPaymentFeeValue === undefined ? '' : col?.mastercardMaxPaymentFeeType === '$' ? `$${col?.mastercardMaxPaymentFeeValue}` : `${col?.mastercardMaxPaymentFeeValue}%`
      col['mastercardMinPaymentFee'] = col?.mastercardMinPaymentFeeValue === '' || col?.mastercardMinPaymentFeeValue === null || col?.mastercardMinPaymentFeeValue === undefined ? '' : col?.mastercardMinPaymentFeeType === '$' ? `$${col?.mastercardMinPaymentFeeValue}` : `${col?.mastercardMinPaymentFeeValue}%`
      col['mastercardProcessingFee'] = col?.mastercardProcessingFeeValue === '' || col?.mastercardProcessingFeeValue === null || col?.mastercardProcessingFeeValue === undefined ? '' : col?.mastercardProcessingFeeType === '$' ? `$${col?.mastercardProcessingFeeValue}` : `${col?.mastercardProcessingFeeValue}%`
      col['mastercardSecondProcessingFee'] = col?.mastercardSecondProcessingFeeValue === '' || col?.mastercardSecondProcessingFeeValue === null || col?.mastercardSecondProcessingFeeValue === undefined ? '' : col?.mastercardSecondProcessingFeeType === '$' ? `$${col?.mastercardSecondProcessingFeeValue}` : `${col?.mastercardSecondProcessingFeeValue}%`

      col['visaIncrementalFee'] = col?.visaIncrementalFeeValue === '' || col?.visaIncrementalFeeValue === null || col?.visaIncrementalFeeValue === undefined ? '' : col?.visaIncrementalFeeType === '$' ? `$${col?.visaIncrementalFeeValue}` : `${col?.visaIncrementalFeeValue}%`
      col['visaMaxPaymentFee'] = col?.visaMaxPaymentFeeValue === '' || col?.visaMaxPaymentFeeValue === null || col?.visaMaxPaymentFeeValue === undefined ? '' : col?.visaMaxPaymentFeeType === '$' ? `$${col?.visaMaxPaymentFeeValue}` : `${col?.visaMaxPaymentFeeValue}%`
      col['visaMinPaymentFee'] = col?.visaMinPaymentFeeValue === '' || col?.visaMinPaymentFeeValue === null || col?.visaMinPaymentFeeValue === undefined ? '' : col?.visaMinPaymentFeeType === '$' ? `$${col?.visaMinPaymentFeeValue}` : `${col?.visaMinPaymentFeeValue}%`
      col['visaProcessingFee'] = col?.visaProcessingFeeValue === '' || col?.visaProcessingFeeValue === null || col?.visaProcessingFeeValue === undefined ? '' : col?.visaProcessingFeeType === '$' ? `$${col?.visaProcessingFeeValue}` : `${col?.visaProcessingFeeValue}%`
      col['visaSecondProcessingFee'] = col?.visaSecondProcessingFeeValue === '' || col?.visaSecondProcessingFeeValue === null || col?.visaSecondProcessingFeeValue === undefined ? '' : col?.visaSecondProcessingFeeType === '$' ? `$${col?.visaSecondProcessingFeeValue}` : `${col?.visaSecondProcessingFeeValue}%`
    }

    if (isCcRemittanceFilterApplied || isCcRemittanceColChecked) {
      col['creditCardRemittanceEmail'] = (col?.creditCardRemittanceEmail && col?.mastersCardAccEmailType === "Remittance") ? col?.creditCardRemittanceEmail : null
    }

    if (isCcPaymentFilterApplied || isCcPaymentColChecked) {
      col['creditCardPaymentEmail'] = (col?.creditCardPaymentEmail && col?.mastersCardAccEmailType === "Payment") ? col?.creditCardPaymentEmail : null
    }

    if (IsPayFilterApplied || isPayColChecked) {
      col['Cash Payment Discount'] = col?.mastersPaymentCashDiscountValue === '' || col?.mastersPaymentCashDiscountValue === null || col?.mastersPaymentCashDiscountValue === undefined ? '' : col?.mastersPaymentCashDiscountType === 'Dollar' ? `$${col?.mastersPaymentCashDiscountValue}` : `${col?.mastersPaymentCashDiscountValue}%`
    }

    return col
  })

  return newResult;
}

export const checkAmexCardConditonsAdded = (cardInfo) => {
  var isAdded = false
  if (cardInfo?.amexProcessingFeeValue || cardInfo?.amexMinPaymentFeeValue || cardInfo?.amexMaxPaymentFeeValue || cardInfo?.amexIncrementalFeeValue || cardInfo?.americanExpressMinPaymnet || cardInfo?.americanExpressMaxPayment || cardInfo?.amexIncrementalPaymentAmount || cardInfo?.isAcceptAmexVariableFee !== null) {
    isAdded = true
  }
  return isAdded
}

export const checkVisaCardConditonsAdded = (cardInfo) => {
  var isAdded = false
  if (cardInfo?.visaProcessingFeeValue || cardInfo?.visaMinPaymentFeeValue || cardInfo?.visaMaxPaymentFeeValue || cardInfo?.visaIncrementalFeeValue || cardInfo?.visaMinPayment || cardInfo?.visaMaxPayment || cardInfo?.visaIncrementalPaymentAmount || cardInfo?.isAcceptVisaVariableFee !== null) {
    isAdded = true
  }
  return isAdded
}

export const checkMasterCardConditonsAdded = (cardInfo) => {
  var isAdded = false
  if (cardInfo?.mastercardProcessingFeeValue || cardInfo?.mastercardMinPaymentFeeValue || cardInfo?.mastercardMaxPaymentFeeValue || cardInfo?.mastercardIncrementalFeeValue || cardInfo?.mastercardMinPayment || cardInfo?.mastercardMaxPayment || cardInfo?.mastercardIncrementalPaymentAmount || cardInfo?.isAcceptMasterCardVariableFee !== null) {
    isAdded = true
  }
  return isAdded
}

// to get master supplier completeness score

// Supplier Name - 0%
// Full Address - 10%
// General Contact Phone - 5%
// General Contact Email - 5%
// Contact Name - 5% X
// General URL - 15%
// EIN - 15%
// Card Acceptance 10% (Accepts amex, MC or Visa = true/false)
// Card remittance 10% (Card remittance Email, Online, Phone etc is set to true) X
// Check Acceptance - 5%
// Check Remittance - 5% 
// ACH Acceptance - 5%
// Global/Location Acceptance - 10%
export const getSupplierCompletenessScore = async (basicInfo = null, cardInfo = null, paymentInfo = null, cardEmailsInfo = null, dispatch) => {
  if (basicInfo || cardInfo || paymentInfo) {
    let fullAddress, contactPhone, contactEmail, contactName, url, ein, cardAcceptance, cardRemittance, checkAcceptance, achAcceptance, checkRemittance, globalAcceptance, totalScore
    fullAddress = contactPhone = contactEmail = contactName = url = ein = cardAcceptance = cardRemittance = checkAcceptance = achAcceptance = checkRemittance = globalAcceptance = totalScore = 0

    if (basicInfo?.address1 && basicInfo?.city && (basicInfo?.state || basicInfo?.abbreviatedState) && basicInfo?.zip) {
      fullAddress = 10
    }

    if (basicInfo?.phone?.toString()?.trim()) {
      contactPhone = 5
    }
    if (basicInfo?.email?.toString()?.trim()) {
      contactEmail = 5
    }
    if (basicInfo?.url) {
      url = 15
    }
    if (basicInfo?.employerIdNumber) {
      ein = 15
    }

    if (cardInfo?.isAcceptAmericanExpress !== null || cardInfo?.isAcceptVisa !== null || cardInfo?.isAcceptMasterCard !== null) {
      cardAcceptance = 10
    }

    cardRemittance = getCardRemittanceScore(cardInfo, cardEmailsInfo)

    if (cardInfo?.isAcceptGlobalAcceptance !== null) {
      globalAcceptance = 10
    }

    if (paymentInfo?.isAcceptCheckPayments !== null) {
      checkAcceptance = 5
    }

    if (paymentInfo?.isAcceptAchPayments !== null) {
      achAcceptance = 5
    }

    if (paymentInfo?.checkAddress1 && paymentInfo?.checkCity && paymentInfo?.checkState && paymentInfo?.checkZip) {
      checkRemittance = 5
    }

    // get contact name score by checking contact name in successfull enablement
    let contactNameData = {}
    if (basicInfo?.id) {
      contactNameData = await dispatch(getContactNameForSuccessfulEnablement(basicInfo?.id)).then((res) => {
        return res?.callRecordings
      }).catch(() => {
        return null
      })
    }

    if (contactNameData && contactNameData?.contactName?.trim()) {
      contactName = 5
    }

    totalScore = fullAddress + contactPhone + contactEmail + contactName + url + ein + cardAcceptance + cardRemittance + checkAcceptance + achAcceptance + checkRemittance + globalAcceptance
    return totalScore
  } else {
    return 0
  }
}

const getCardRemittanceScore = (cardInfo, cardEmailsInfo) => {
  if (cardInfo?.isAcceptCardPaymentByEmail || cardInfo?.isAcceptCardPaymentByOnlinePortal || cardInfo?.isAcceptCardPaymentByPhone || cardInfo?.isAcceptCardPaymentByFax || cardInfo?.isAcceptPointOfSalePortal) {
    if (cardInfo?.isAcceptCardPaymentByEmail && cardEmailsInfo?.[0]?.email) {
      return 10
    }

    if (cardInfo?.isAcceptCardPaymentByOnlinePortal) {
      if (cardInfo?.isAcceptEcommercePortal || cardInfo?.isAcceptInAppPortal || cardInfo?.isAcceptPortal || cardInfo?.isAccept3rdPartyPortal) {
        if (cardInfo?.isAcceptEcommercePortal) {
          return 10
        }

        if (cardInfo?.isAcceptInAppPortal) {
          return 10
        }

        if (cardInfo?.isAcceptPortal) {
          if (cardInfo?.portalUrl) {
            return 10
          }
        }

        if (cardInfo?.isAccept3rdPartyPortal) {
          if (cardInfo?.thirdPartyPortalUrl) {
            return 10
          }
        }
      }
    }

    if (cardInfo?.isAcceptCardPaymentByPhone) {
      if (cardInfo?.isAcceptPOTSPhone) {
        if (cardInfo?.cardPaymentByPhoneValue?.toString()?.trim()) {
          return 10
        }
      }

      if (cardInfo?.isAcceptIVRPhone) {
        if (cardInfo?.cardPaymentIVRPhone?.toString()?.trim()) {
          return 10
        }
      }
    }

    if (cardInfo?.isAcceptCardPaymentByFax) {
      if (cardInfo?.cardPaymentByFaxValue && cardInfo?.cardPaymentByFaxValue.length >= 10) {
        return 10
      }
    }

    if (cardInfo?.isAcceptPointOfSalePortal) {
      return 10
    }
    return 0
  } else {
    return 0
  }
}

export const getGlobalAcceptanceValue = async (cardData, masterId, dispatch) => {
  if (cardData?.isAcceptGlobalAcceptance === true) {
    return 'Global'
  }

  if (cardData?.isAcceptGlobalAcceptance === null) {
    return 'Unknown'
  }

  if (cardData?.isAcceptGlobalAcceptance === false) {
    const locationResults = await dispatch(
      getLocationMastersByMasterIds([masterId])
    ).then(locMasters => {
      return locMasters
    })

    if (locationResults && locationResults?.length > 0) {
      return 'Location'
    } else {
      return 'Selective'
    }
  }
}

export const getParsedAddress = (addressResult) => {
  let add1 = ''
  let add2 = ''
  // get Address Line 1
  addressResult.result.find((data) => { if (data.tag === 'AddressNumberPrefix') { add1 += data.value } })
  addressResult.result.find((data) => { if (data.tag === 'AddressNumber') { add1 += !add1 ? data.value : ' ' + data.value } })
  addressResult.result.find((data) => { if (data.tag === 'AddressNumberSuffix') { add1 += !add1 ? data.value : ' ' + data.value } })
  addressResult.result.find((data) => { if (data.tag === 'StreetNamePreDirectional') { add1 += !add1 ? data.value : ' ' + data.value } })
  addressResult.result.find((data) => { if (data.tag === 'StreetName') { add1 += !add1 ? data.value : ' ' + data.value } })
  addressResult.result.find((data) => { if (data.tag === 'StreetNamePostType') { add1 += !add1 ? data.value : ' ' + data.value } })
  addressResult.result.find((data) => { if (data.tag === 'StreetNamePostDirectional') { add1 += !add1 ? data.value : ' ' + data.value } })
  addressResult.result.find((data) => { if (data.tag === "USPSBoxType") { add1 += !add1 ? data.value : ' ' + data.value } })
  addressResult.result.find((data) => { if (data.tag === "USPSBoxID") { add1 += !add1 ? data.value : ' ' + data.value } })

  // get Address Line 2
  addressResult.result.find((data) => { if (data.tag === 'SubaddressType') { add2 += data.value } })
  addressResult.result.find((data) => { if (data.tag === 'SubaddressIdentifier') { add2 += !add2 ? data.value : ' ' + data.value } })
  addressResult.result.find((data) => { if (data.tag === 'OccupancyType') { add2 += !add2 ? data.value : ' ' + data.value } })
  addressResult.result.find((data) => { if (data.tag === 'OccupancyIdentifier') { add2 += !add2 ? data.value : ' ' + data.value } })
  let city = addressResult.result.find((data) => data.tag === 'PlaceName')
  let state = addressResult.result.find((data) => data.tag === 'StateName')
  let country = addressResult.result.find((data) => data.tag === 'CountryName')
  let zip = addressResult.result.find((data) => data.tag === 'ZipCode')
  return {
    add1,
    add2,
    city,
    state,
    country,
    zip
  }
}

export const checkZip = (zip) => {
  let isValidZip = true

  if (/^\d{5}((-|\s){0,1}\d{4})?$/.test(zip) || /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z]( ?)[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i.test(zip)) {
    isValidZip = true
  } else {
    isValidZip = false
  }
  return isValidZip;
}

export const convertAddress = (address) => {
  let regex = /\b(p\s*\.?\s*o\s*\.?\s*box)\s*/gi;;

  if (regex.test(address)) {
    let tmp = address.replace(regex, 'PO Box ');
    let valueTmp = tmp.replace(/PO Box\s*(?![0-9])/, 'PO Box ');
    address = valueTmp.replace(/\s+/g, ' ').trim();
  }

  return address
}

export const onSupplierCardAccUpdate = (obj1, obj2, removeEmailValues, addEmailValues, suppliercardEmailsInfo) => {
  let fields = ['isAcceptAmericanExpress', 'isAcceptMasterCard', 'isAcceptVisa', 'isAcceptCardPaymentByPhone', 'isAcceptPOTSPhone', 'isAcceptIVRPhone', 'isAcceptCardPaymentByFax', 'isAcceptCardPaymentByOnlinePortal', 'isAcceptEcommercePortal', 'isAcceptPortal', 'isAccept3rdPartyPortal', 'isAcceptInAppPortal', 'isAcceptPointOfSalePortal', 'cardPaymentByPhoneValue', 'cardPaymentIVRPhone', 'cardPaymentByFaxValue', 'portalUrl', 'thirdPartyPortalUrl']
  let isDiff = false

  if (Object.keys(removeEmailValues).length > 0 || Object.keys(addEmailValues).length > 0) {
    return true
  }

  if (suppliercardEmailsInfo?.[0] && suppliercardEmailsInfo?.[0] !== undefined) {
    return true
  }

  if (!obj1 || !obj2) {
    return false
  }
  fields.every(field => {
    if (!obj1.hasOwnProperty(field) || !obj2.hasOwnProperty(field) || (!obj1[field] && !obj2[field])) {
      isDiff = false
    } else if (obj1[field] !== obj2[field]) {
      if (field === 'cardPaymentByPhoneValue' || field === 'cardPaymentIVRPhone') {
        let newPhn = obj1[field]?.toString()?.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
        let oldPhn = obj2[field]?.toString()?.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')

        if (newPhn === oldPhn) {
          isDiff = false
          return
        } else {
          isDiff = true
          return
        }
      }
      isDiff = true
      return false
    }
    return true
  })

  return isDiff
}

export const getEmailAndPhoneFromContacts = async (listSup, matchedSup, dispatch) => {
  let contacts = []
  const supEmail = listSup?.email && /^\d+$/.test(listSup?.email) ? listSup?.email : null
  const supPhone = listSup?.phone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(listSup?.phone) && /^\d+$/.test(listSup?.phone) ? listSup?.phone : null
  const matchedSupEmail = matchedSup?.email && /^\d+$/.test(matchedSup?.email) ? matchedSup?.email : null
  const matchedSupPhone = matchedSup?.phone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(matchedSup?.phone) && /^\d+$/.test(matchedSup?.phone) ? matchedSup?.phone : null
  let contactIds = []
  contactIds.push(supEmail, supPhone, matchedSupEmail, matchedSupPhone)
  contactIds = contactIds?.filter(data => data && /^\d+$/.test(data))
  const uniqueContactIds = [...new Set(contactIds)]
  if (uniqueContactIds && uniqueContactIds?.length) {
    contacts = await getAllContactsByIds(uniqueContactIds, dispatch)
  }
  return contacts
}

// to get phone value from contacts
export const getContactPhoneValue = (value = '', contacts = []) => {
  const phone = value && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(value) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(value) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(value) && /^\d+$/.test(value)) && /^\d+$/.test(value) ? contacts?.find(data => data?.id === parseInt(value))?.phone : (value || '')
  return phone
}

// to get email value from contacts
export const getContactEmailValue = (value = '', contacts = []) => {
  const email = value && /^\d+$/.test(value) && /^\d+$/.test(value) ? contacts?.find(data => data?.id === parseInt(value))?.email : (value || '')
  return email
}

export const sortGlobalSearchResults = (data) => {
  const result = data?.sort((a, b) => {
    // First, prioritize where ResultType is not "contact"
    if (a.ResultType !== "contact" && b.ResultType === "contact") {
      return -1; // Move 'a' before 'b'
    }
    if (b.ResultType !== "contact" && a.ResultType === "contact") {
      return 1; // Move 'b' before 'a'
    }

    // Then, prioritize by isMaster
    return Number(b?.isMaster) - Number(a?.isMaster);
  })
  return result
}

export const extractMainContentFromHtml = (html) => {
  // Create a temporary DOM element to parse the input HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  // Store the extracted main content
  const mainContent = [];

  // Dynamically extract visible and relevant text content
  const elementsToCheck = tempDiv.querySelectorAll("div, p, span");
  elementsToCheck.forEach((element) => {
    const text = element.textContent.trim();
    // Filter out empty lines, metadata, and duplicate entries
    if (
      text &&
      !text.match(/^(From:|Sent:|To:|Subject:)/) && // Filter metadata
      !mainContent.includes(text) // Avoid duplicates
    ) {
      mainContent.push(text);
    }
  });
  // Return the cleaned content as an array or joined string
  return mainContent.join("\n");
}

export const convertContentToHtml = (content) => {
  // Split the content into lines if it's a single string
  const lines = Array?.isArray(content) ? content : content?.split("\n");

  // Wrap each line in a <p> tag
  const htmlContent = lines?.map(line => `<p>${line}</p>`)
    .join("\n"); // Join the HTML lines into a single string

  return htmlContent;
}

export const formatRelativeDate = (dateString) => {
  const parsedDate = new Date(dateString);
  const now = new Date();
  const diffInMs = now - parsedDate;

  // Convert the difference to units of time
  const seconds = Math.floor(diffInMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  // Format the output based on the difference
  if (years > 0) {
    return `${years} year${years > 1 ? 's' : ''} ago`;
  } else if (months > 0) {
    return `${months} month${months > 1 ? 's' : ''} ago`;
  } else if (days > 0) {
    return `${days} day${days > 1 ? 's' : ''} ago`;
  } else if (hours > 0) {
    return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  } else if (minutes > 0) {
    return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  } else {
    return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
  }
}



export const formatDate = (dateString) => {
  const date = new Date(dateString); // Parse the input date string
  if (isNaN(date)) return null; // Handle invalid dates

  // Extract date components
  const day = date.getDate().toString().padStart(2, '0'); // Ensure two digits
  const month = date.toLocaleString('en-US', { month: 'short' }); // Short month name
  const year = date.getFullYear();
  const weekday = date.toLocaleString('en-US', { weekday: 'short' }); // Short weekday name
  const hours = date.getHours().toString().padStart(2, '0'); // Ensure two digits
  const minutes = date.getMinutes().toString().padStart(2, '0'); // Ensure two digits
  const seconds = date.getSeconds().toString().padStart(2, '0'); // Ensure two digits

  // Combine components into desired format
  return `${weekday}, ${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
};

export const getMinDayCount = (lastEmailSentDate, lastCalledDate) => {
  const today = new Date();

  const emailDate = new Date(lastEmailSentDate);
  const calledDate = new Date(lastCalledDate);

  const emailDays = Math.floor((today - emailDate) / (1000 * 60 * 60 * 24));
  const calledDays = Math.floor((today - calledDate) / (1000 * 60 * 60 * 24));

  return Math.min(emailDays, calledDays);
}

const mimeToExtensionMap = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/gif": "gif",
  "application/pdf": "pdf",
  "text/plain": "txt",
  "application/msword": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
  "application/vnd.ms-excel": "xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
  "application/zip": "zip",
  "application/json": "json",
  "text/csv": "csv"
};

export const getFileExtension = (mimeType) => {
  return mimeToExtensionMap[mimeType] || "bin"; // Default to "bin" if unknown
};

export const calculatePaymentCount = (timeType, timeFrame, paymentCount) => {
  const paymentCountPerUnit = timeFrame.rate / timeType;
  const annualizedPaymentCount = paymentCount * paymentCountPerUnit;
  return Math.round(annualizedPaymentCount);
};

export const isToday = (date) => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
}

export const isYesterday = (date) => {
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  return (
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear()
  );
}

export const isTodayOrTomorrow = (date) => {
    if (isToday(new Date(date))) {
      return 'Today'
    } else if (isYesterday(new Date(date))) {
      return 'Tomorrow'
    } else {
      return date
    }
}


export const extractLastParagraphNote = (html) => {
  const container = document.createElement('div');
  container.innerHTML = html;

  const paragraphs = container.querySelectorAll('p');
  const lastParagraph = paragraphs[paragraphs.length - 1];

  if (!lastParagraph) return null;

  let foundAnchor = false;
  let note = '';

  lastParagraph.childNodes.forEach((node) => {
    if (node.nodeName === 'A' || node.nodeName === 'a') {
      note += node.textContent;
      foundAnchor = true;
    } else if (node.nodeName === 'BR' || node.nodeName === 'br') {
      note += '\n';
    } else if (node.nodeType === Node.TEXT_NODE) {
      if (foundAnchor || !lastParagraph.querySelector('a')) {
        note += node.textContent;
      }
    }
  });

  return note.trim();
};

export const getChunkSizes = async (total, chunkSize, selectedCompany) => {
  const chunks = [];

  let remaining = total?.count;
  let start = 1;
  let offset = 0;

  while (remaining > 0) {
    const currentChunk = remaining >= chunkSize ? chunkSize : remaining;
    const end = start + currentChunk - 1;

    chunks.push({
        suppliername: selectedCompany[0]?.companyName,
        listDataInfo: {
            count: `${start}-${end}`,
            offset,
            limit: currentChunk
          },
          isDownloaded: false
        });

        remaining -= currentChunk;
        start = end + 1;
        offset += currentChunk;
      }
    return chunks;
};